exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cart__header[data-v-00207d1c]{background-color:#6aceff;padding:65px 20px 0;width:100%}.cart__header .backlink[data-v-00207d1c]{margin-bottom:5px}.cart__header .cart__header-title-container[data-v-00207d1c]{display:flex;align-items:flex-end}.cart__header img[data-v-00207d1c]{width:100px;margin-left:35px}.cart__header span[data-v-00207d1c]{color:#fff;font-family:ClanFFBlack;font-size:25px;margin-top:25px;text-transform:uppercase;flex:1;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00207d1c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cart/CartHeader.vue
// module id = 652
// module chunks = 0